import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../providers/authentication';

const PrivateRoute = () => {
  const auth = useAuth();
  return auth?.isAuthenticated ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
